import {dashboardChartColors} from '../../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../../common/BarchartColumn';

export const prop = 'status';

export const config = (labels) =>
	barchartColumnConfig({
		id: 'byType',
		label: labels.byType,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.fraud,
				data: [item.riskFraud],
				color: dashboardChartColors.red[3]
			},
			{
				name: utilLabels.significant,
				data: [item.riskSigni],
				color: dashboardChartColors.red[2]
			},
			{
				name: utilLabels.inherent,
				data: [item.riskInherent],
				color: dashboardChartColors.red[1]
			}
		]
	});
